import { Box, Container, Grid, Typography, Pagination } from "@mui/material";
import { motion } from "framer-motion";
import { blogPosts } from "../data/blog";
import { BlogCard } from "../components/BlogCard";
import { useState } from "react";
import { fadeIn, staggeredContainer } from "../utils/animations";

export const Blog = () => {
  const [page, setPage] = useState(1);
  const postsPerPage = 3;
  const totalPages = Math.ceil(blogPosts.length / postsPerPage);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const paginatedPosts = blogPosts.slice(
    (page - 1) * postsPerPage,
    page * postsPerPage
  );

  return (
    <Box
      component="main"
      sx={{
        py: 8,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container maxWidth="lg">
        <motion.div variants={fadeIn} initial="hidden" animate="visible">
          <Typography
            variant="h1"
            gutterBottom
            sx={{
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: 700,
              mb: 3,
            }}
          >
            Blog Posts
          </Typography>
          <Typography
            variant="h5"
            color="text.secondary"
            paragraph
            sx={{ mb: 6 }}
          >
            Thoughts, insights, and experiences from my journey
          </Typography>

          <motion.div
            variants={staggeredContainer}
            initial="hidden"
            animate="visible"
            viewport={{ margin: "-100px" }}
          >
            <Grid container spacing={2}>
              {paginatedPosts.map((post, index) => (
                <Grid item xs={12} md={6} key={post.id}>
                  <BlogCard {...post} index={index} />
                </Grid>
              ))}
            </Grid>
            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  size="small"
                  color="secondary"
                />
              </Box>
            )}
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Blog;
